<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <v-app>
        <v-row>
            <v-col>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Buscar"
                ></v-text-field>

                <v-data-table
                    dense
                    :headers="headers"
                    :items="itens"
                    :search="search"
                    class="elevation-1"
                    :loading="loading"
                    loading-text="Carregando..."
                >
                    <template v-slot:top>
                    <v-toolbar flat color="white">
                        <v-toolbar-title>{{title}}</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-btn class="mb-2" color="warning" dark @click="iniciar"
                        ><v-icon>cached</v-icon></v-btn
                        >
                        <v-btn class="mb-2" color="success" dark @click="openDialog"
                        ><v-icon>add_box</v-icon></v-btn
                        >
                    </v-toolbar>
                    </template>

                    <template v-slot:item.price="{ item }">
                          {{item.price | guarani }}
                    </template>
                    
                    <!-- ATIVO -->
                    <template v-slot:item.ativo="{ item }">
                      <v-chip
                          class="ma-0"
                          :color="item.ativo ? '#00897B' : '#E53935'"
                          text-color="white"
                          small
                        >
                          {{item.ativo ? 'Sim' : 'Não'}}
                      </v-chip>
                    </template>

                    <!-- DATA SE TIVER -->
                    <!-- 
                    <template v-slot:item.nascimento="{ item }">
                        {{ formatDate(item.nascimento) }}
                    </template> -->

                    <template v-slot:item.acoes="{ item }">
                    <v-icon color="primary" class="mr-2" @click="editItem(item)"
                        >mdi-pencil</v-icon
                    >
                    <v-icon  color="danger" @click="deleteItem(item)"
                        >mdi-delete</v-icon
                    >
                    </template>

                    <template v-slot:no-data>
                    <v-btn color="primary" @click="iniciar">Reiniciar</v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-row>
            <v-dialog
                v-model="dialog"
                max-width="800px"
                persistent
                scrollable
                class="dialog-above-menu"
            >
                <!-- <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                    <v-icon>add_box</v-icon>
                </v-btn>
                </template> -->
            <v-form ref="formService" v-model="formValido" lazy-validation>
                <!-- <v-card color="#EEEEEE"> -->
                <v-card :color="colorDialog">
                    <v-card-title :style="{ color: corTitulo }">
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    
                    <v-card-text class="custom-scroll" :style="{ '--scrollbar-color': corTitulo }">
                        <!-- <v-container> -->
                            <v-row class="no-gutters">
                                <!-- <v-col cols="2" sm="2" md="2">
                                    <v-text-field v-model="editedItem.id" label="ID" disabled></v-text-field>
                                </v-col> -->
                                <!-- <h4>Dados Principais</h4> -->
                            </v-row>
                            <v-card :color="colorDialog" elevation="10">
                              <v-card-title>Dados Principais</v-card-title>

                              <v-card-text>
                                <v-row class="no=gutters">
                                  <v-col cols="12">
                                      <v-text-field
                                        type="text"
                                        label="Nome do serviço"
                                        filled
                                        :background-color="colorInput"
                                        class="mr-1"
                                        style="line-height: 3"
                                        prepend-inner-icon="mdi mdi-percent-box"
                                        v-model="editedItem.name"
                                      ></v-text-field>
                                    </v-col>
                                  
                                    <v-col cols="12">
                                    <v-textarea 
                                    
                                      elevation="2"
                                      label="Descrição" 
                                      auto-grow
                                      
                                      :background-color="colorInput"
                                      rows="3" 
                                      prepend-inner-icon="mdi-note-text"
                                      v-model="editedItem.description"
                                    ></v-textarea>
                                    </v-col>

                                    <v-col cols="12" md="6" sm="12">
                                      <v-text-field
                                        type="text"
                                        label="Valor"
                                        filled
                                        :background-color="colorInput"
                                        class="mr-1"
                                        style="line-height: 3"
                                        prepend-inner-icon="mdi mdi-percent-box"
                                        @input="formataInputGuarani($event, 'price')"
                                        v-model="editedItem.price"
                                      ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" md="6" sm="12">
                                      <v-text-field
                                        :rules="textRules"
                                        type="number"
                                        label="Duração em min."
                                        filled
                                        :background-color="colorInput"
                                        class="mr-1"
                                        style="line-height: 3"
                                        prepend-inner-icon="mdi mdi-percent-box"
                                        v-model="editedItem.duration"
                                      ></v-text-field>
                                    </v-col>

                                </v-row>

                              </v-card-text>
                            </v-card>
                    </v-card-text>
                    
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close"
                        >Cancelar</v-btn
                        >
                        <v-btn
                        color="pink accent-3"
                        text
                        @click="save"
                        :disabled="!formValido"
                        >Salvar</v-btn
                        >
                    </v-card-actions>
                </v-card>
          </v-form>
        </v-dialog>
      </v-row>

    </v-app>
  </Layout>
</template>


<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import { ApiInv } from "./ApiInv";
//import { ApiCmp } from "./ApiCmp";

//import { ApiFac } from "../fac/ApiFac";

import mensagemMixin from "@/mixins/mensagensMixin.js";

export default {
  name: "Services",
  components: {
    Layout,
    PageHeader,
  },
  props: [],
  mixins: [mensagemMixin],
  data() {
    return {
      title: "Serviços",
      items: [
        {
          text: "Dashboard",
          href: "/home",
        },
        {
          text: "Serviços",
          active: true,
        },
      ],
      itens: [],
      empresa:{},
      api: new ApiInv(),
      //ApiFac: new ApiFac(),
      loading: false,
      search: "",
      file: null,
      recurso: "serviço",
      colorInput: "white", //amarelo
      //colorInput: "#FFE57F", //amarelo
      colorCheckbox: "#26A69A",
      corTitulo: "#795548",
      //colorInput: "#EDE7F6",
      //colorDialog: "#FFD740",
      //colorDialog: "rgba(255, 215, 64, 0.95)", //cor unica amarelo:#f2c438 roxo:#82566a
      colorDialog: "#EEEEEE",
      headers: [
        { text: "ID", value: "id" },
        { text: "Nome", align: "start", sortable: false, value: "name" },
        { text: "Preço", align: "end", sortable: false, value: "price" },
        { text: "Ações", value: "acoes", sortable: false },
      ],
      dialog: false,
      editedIndex: -1,
      editedItem: { 
        id: -1, 
        name: null,
        description: null,
        price: null,
        duration: null, 
      },
      defaultItem: { 
        id: -1, 
        name: null,
        description: null,
        price: null,
        duration: null, 
      },
      textRules: [(v) => !!v || "Requerido"],
      formValido: true,
    };
  },
  created() {
    if((localStorage.getItem("empresa") !== 'undefined') && (localStorage.getItem("empresa") !== null)){
      this.empresa = JSON.parse(localStorage.getItem("empresa"))
      /* NOVO...Quando dava refresh na página ele perdia o estado ...fazer em todos os componentes */
      this.$store.dispatch('company/changeEmpresa', this.empresa)
    } else {
      this.mensagem("Selecione uma empresa!", "Atenção", "warning") //mixin
      this.empresa = {}
      this.$router.push('/empresas')
    }

    this.iniciar()

  },
  mounted(){
  },
  methods: {
    async iniciar() {
      try {
        this.loading = true;
        let resultado = await this.api.getServices(-1, "", "", this.empresa.id);
        this.itens = resultado;
      } catch (error) {
        alert(error);
      } finally {
        this.loading = false;
      }
    },
    async openDialog() {
      //await new Promise(resolve => setTimeout(resolve, 100))
      this.dialog = true;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    editItem(item) {
      console.log(item);
      this.editedIndex = this.itens.indexOf(item);
      this.editedItem = Object.assign({}, item);
      /* ATENÇÃO IMPORTANTÍSSIMO */
      this.formataInputGuarani(this.formataGuarani(this.editedItem.price), 'price')
      //delete this.editedItem.celular
      //this.$set(this.editedItem, "celular", {number: null, country:{}, valid: null})
      //this.editedItem.celular.number = item.celular
      this.dialog = true;
    },
    async deleteItem(item) {
      this.$swal
        .fire({
          title: "Tem certeza?",
          html: `Apagar o ${this.recurso} <br><b>${item.nome}</b>`,
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Sim!",
          cancelButtonText: "Não!",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            let resposta = await this.api.delFornecedor(item.id);
            this.iniciar();
            if (resposta.status == 204) {
              this.$toastr.s(`Eliminado ${item.nome}`);
            } else if (resposta.status >= 400) {
              if (resposta.data.detail) {
                this.$toastr.e(`${resposta.data.detail}`);
              } else if (resposta.data) {
                this.$toastr.e(`${JSON.stringify(resposta.data)}`);
              } else {
                this.$toastr.e(`${resposta.statusText}`);
              }
            }
          } else {
            this.$swal.fire("Cancelado!", `O ${this.recurso} foi mantido.`, "info");
          }
        });
    },

    validate () {
      if(this.$refs.formService.validate()){
        return true
      }else {
        return false
      }
    },

    async save() {
      if(!this.validate()){
        console.log('não passou na validação');
        this.mensagem("Os campos em vermelho são obrigatórios", "Aviso!", "warning",15)
        return false;
      } else {
        console.log('ok passou na validação');
      }
        console.log("======================save====================================");
        console.log(this.editedItem)
        console.log("=============================================================");
      

      if (this.editedItem.name && this.editedItem.name.length <= 3) {
        this.$swal({
          title: "Erro!",
          text: "Campo nome deve ter mais de três caracteres",
          icon: "error",
        });
        return false;
      }

      /*  */
      /* ADICONANDO OS CAMPOS NORMAIS */
      const fornecedor = {}
      for(const key in this.editedItem){
        console.log(`${key}->${this.editedItem[key]}`);
        if(this.editedItem[key] !== null && this.editedItem[key] !== "")
            //fornecedor.append(key, fornecedor[key]);
            fornecedor[key] = this.editedItem[key];
      }

      /* ADICIONANDO OS _id tem que ser igual ao nome que está no model no backend */
      const relacionamentos = [] 
      relacionamentos.forEach(relacionamento => { 
        if(this.editedItem[relacionamento] !== undefined && this.editedItem[relacionamento] !== null && this.editedItem[relacionamento].id !== null)
            fornecedor[`${relacionamento}_id`] = this.editedItem[relacionamento].id
      })

      /* CAMPOS EXTRAS SE TIVER */
      //fornecedor.celular = this.editedItem.celular.number
      //fornecedor.telefone = this.editedItem.telefone.number

      /* ADICIONAR IMAGEM SE TIVER */
      if(this.file)
        fornecedor.imagem = this.file

      console.log('zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzz');
      console.log('Fornecedor ',fornecedor)
      console.log('zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzz');
      /*  */

      /* ADICIONANDO A EMPRESA */
      fornecedor.empresa = this.empresa.id

      /* LIMPAR OS CAMPOS FORMATADOS COM GUARANI */
      fornecedor.price = this.limpaGuarani(this.editedItem.price)

      /*  */
      const obj = new FormData();
      for (const key in fornecedor) {
        if (key == "imagem") {
          if (fornecedor[key] !== null) obj.append("imagem", fornecedor[key]);
        } else {
          obj.append(key, fornecedor[key]);
        }
      }

      try {
        this.loading = true;
        let resposta = await this.api.saveService(obj);
        if (resposta.data.id) {
          this.mensagem(`${this.recurso} salvo com sucesso!`, '', 'success', 3);
          this.close()
          this.iniciar()
        } else if (resposta.status >= 400) {
          if (resposta.data.detail) {
            this.mensagem(resposta.data.detail, "Aviso", "error");
          } else if (resposta.data) {
            this.mensagem(JSON.stringify(resposta.data), "Atenção", "error");
          } else {
            this.mensagem("Erro desconhecido", "Erro", "error");
          }
        }
      } catch (error) {
        this.$swal({ title: "Erro!", text: error.toString(), icon: "error" });
      } finally {
        this.loading = false;
      }
    },


    /* USAR PARA LISTAR RELACIONAMENTOS */
    /* async listarPaises() {
      try {
        this.loading = true;
        const paises = await this.apiFac.getPais(-1);
        if (paises.status >= 400) {
          if (paises.status == 403) {
            //this.mensagem("Sem permissão para executar essa ação", "Atenção", "error");
            this.$toastr.w(`${paises.statusText}`);
            this.paises = [];
          } else if (paises.status == 404) {
            this.mensagem("Pais não cadastrado", "Atenção", "warning");
          } else {
            this.mensagem(paises.statusText, "Atenção", "warning");
          }
        } else {
          this.paises = paises;
        }
      } catch (error) {
        this.mensagemErro('Países: ', error);
      } finally {
        this.loading = false;
      }
    }, */

    /* FORMATA DATA E EXIBE CARACTERES NO CASO DE NÃO TER DATA */
    formatDate(date) {
      /* recebe a data 2023-01-01 e retorna 01/01/2023 ou '-----' */
      const formattedDate = this.moment(date).format("DD/MM/YYYY");
      return this.moment(date).isValid() ? formattedDate : "-----";
    },

    formataInputGuarani(event, campo){
      console.log('=======================================================');
      console.log('=======================================================');
      console.log(event);
      console.log(campo);
        if(!event)
          return false
        console.log('event->', campo, event)
        const valor = this.limpaGuarani(event)
        const formatter = new Intl.NumberFormat('es-PY', {
        style: 'currency',
        currency: 'PYG',
        minimumFractionDigits: 0, // Defina como 0 para formatar como moeda inteira
        maximumFractionDigits: 0  // Defina como 0 para formatar como moeda inteira
      });

      //return formatter.format(event)
      const resultado = formatter.format(valor)

      console.log('resultado', resultado)
      console.log(isNaN(resultado))
      
      /* this.editInputItem */
      this.editedItem[campo] = resultado !== 'Gs. NaN' ? resultado : ""
      

    },

    formataGuarani(arg){
        /* 
        recebe um valor sujo ex: 1.000
        devolve limpo ex: 1000
       */
        console.log("formataGuarani", arg)
        const formatter = new Intl.NumberFormat('es-PY', {
        style: 'currency',
        currency: 'PYG',
        minimumFractionDigits: 0, // Defina como 0 para formatar como moeda inteira
        maximumFractionDigits: 0  // Defina como 0 para formatar como moeda inteira
      });

      return formatter.format(arg)
    },

    limpaGuarani(arg){
        /* 
        recebe um valor sujo com caracteres ex: G$1.000
        devolve limpo ex: 1000
       */
        console.log('limpaGuarani -> arg: ', arg)
        if(arg === 0 || arg =='NaN' || arg === null)
          return false
        const formattedValue = arg
        // Verifique se a string contém apenas caracteres numéricos...quando passava so numro dava erro
        if (/^[0-9.-]+$/.test(formattedValue)) return formattedValue

        // Remova os caracteres não numéricos da string formatada
        const numericString = formattedValue.replace(/[^\d.-]/g, '');
        // Converta a string numérica em um número
        //const numericValue = parseFloat(numericString);
        //const numericValue = parseInt(numericString);
        const numericValue = numericString.replace(/\./g, '')
        //console.log('numericValue->', formattedValue, numericString, numericValue)
        
        return parseInt(numericValue)

    },



  },


  computed: {
    formTitle() {
      return (this.editedIndex === -1 ? "Novo " : "Editar ") + this.recurso;
    },
    /* Usar computed para quando usar tradução personalizar */
    /* SemDadosComputed(){
      let texto = `No data available`
      if(this.editedItem.selectedPais){
          if(this.editedItem.selectedPais.sigla === 'PY')
            texto = `Datos indisponíbles`
          else if(this.editedItem.selectedPais.sigla === 'BR')
            texto = `Dados indisponíveis`
      }
      return texto
    }, */
/*     hintCelularComputed(){
        if(this.editedItem.celular !== null && this.editedItem.celular.valid !==undefined && this.editedItem.celular.valid !==null)
            return (this.editedItem.celular.valid ? `Celular válido ${this.editedItem.celular.number}` : `Inválido ${this.editedItem.celular.valid}`)
        return ''
    },
 */  
    /* MASCARAS */





    /* ICONES */
    /* iconNameComputed() {

        if(this.editedItem.genero !== null){
            if(this.editedItem.genero === 'masculino') 
                return 'mdi-face-man'
            if(this.editedItem.genero === 'feminino') 
                return 'mdi-face-woman'
        }

        return 'mdi-account'
    }, */
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
};
</script>


<style scoped>
.dialog-above-menu {
  /* para o modal não ficar atraz do menu do template */
  z-index: 1000; /* Defina um valor alto para o z-index */
  background-color: gray;
}
.custom-tel-input .v-select__selections {
  margin-left: 5px;
  justify-content: center;
}
.custom-tel-input .v-input__slot {
  /* quando aplica dense no vue-tel-input-vuetify
  o select da bandeira fica menor, essa linha iguala a
  altura com o input do telefone
   */
  height: 53px !important;
}




  /* Personalize o scroll do v-dialog */
  .custom-scroll {
    /* max-height: 400px; */ /* Defina a altura máxima do conteúdo do dialog */
    /* overflow-y: auto; */ /* Habilita o scroll vertical quando o conteúdo excede a altura máxima */
    scrollbar-width: thin; /* Tamanho da barra de scroll (opcional) */
  }

  /* Personalize o estilo da barra de scroll (opcional) */
  .custom-scroll::-webkit-scrollbar {
    width: 8px;
  }

  .custom-scroll::-webkit-scrollbar-thumb {
    background-color: var(--scrollbar-color);
  }
</style>



<style scoped>
/* OBS:
deve existir somente no componente queu possui o dialog
somente esta classe como scoped
a classe dialog-above-menu estava escapando de outros componentes
 */
.v-dialog__content{
    align-items: flex-start !important;
    justify-content: flex-end !important;
    top: -25px !important;
    left: 25px !important;
    bottom: -10px !important;
    /* bottom: -10px !important; */
    z-index: 1006 !important;
    
  }
  
</style>

<style>
.theme--light.v-text-field--filled > .v-input__control > .v-input__slot {
  /*  background-color: red !important; */
  border: solid 1px rgb(204, 201, 201) !important;
  border-radius: 0px !important;
  height: 50px !important;
  margin-bottom: -15px !important;
 /*  margin-top: -10px !important; */
}
</style>


